// /app/frontend/src/components/frugal-v2/components/TrialBanner.jsx
// Trial countdown banner + expired blocker

import React, { useState } from 'react';
import { AlertTriangle, Clock, Lock, X } from 'lucide-react';
import UpgradeModal from './UpgradeModal';

const TrialBanner = ({ subscription, token, t }) => {
  const [dismissed, setDismissed] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (!subscription || subscription.loading) return null;

  const days = subscription.daysRemaining;
  const expired = subscription.isTrialExpired;
  const isActive = subscription.isActive;

  // Don't show if active subscription or no warning needed
  if (isActive || (!expired && !subscription.showUpgradeBanner)) return null;
  if (dismissed && !expired) return null; // Can dismiss warning, NOT expired

  const isUrgent = expired || days <= 3;
  const colorClass = expired
    ? 'bg-rose-600 border-rose-700'
    : isUrgent
    ? 'bg-rose-500/95 border-rose-600'
    : 'bg-amber-500/95 border-amber-600';

  return (
    <>
      <div className={`${colorClass} border-b shadow-lg`} data-testid="trial-banner">
        <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center gap-3">
          <div className="flex-shrink-0">
            {expired ? <Lock className="w-6 h-6 text-white" /> : <Clock className="w-6 h-6 text-white" />}
          </div>
          <div className="flex-1 min-w-0">
            {expired ? (
              <>
                <div className="text-white font-semibold text-sm">
                  Tu periodo de prueba ha finalizado
                </div>
                <div className="text-white/95 text-xs mt-0.5">
                  Tu informacion sigue guardada. Activa tu plan para seguir usando Zensaver sin interrupciones.
                </div>
                {typeof subscription.daysUntilDeletion === 'number' && subscription.daysUntilDeletion >= 0 && (
                  <div className="mt-1.5 inline-flex items-center gap-1.5 bg-white/15 px-2 py-0.5 rounded text-[11px] text-white/95 font-medium">
                    <AlertTriangle className="w-3 h-3" />
                    Tu informacion sera borrada en <strong>{subscription.daysUntilDeletion} {subscription.daysUntilDeletion === 1 ? 'dia' : 'dias'}</strong>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="text-white font-semibold text-sm">
                  Tu prueba gratuita termina en <span className="font-bold">{days} {days === 1 ? 'dia' : 'dias'}</span>
                </div>
                <div className="text-white/90 text-xs mt-0.5 hidden sm:block">
                  Para mantener activo el calculo de Daily Zen y el escaneo de correos, selecciona tu plan. Tu configuracion ya esta guardada.
                </div>
              </>
            )}
          </div>
          <button
            onClick={() => setShowUpgrade(true)}
            data-testid="trial-banner-upgrade-btn"
            className="px-4 py-2 bg-white text-slate-900 rounded-lg text-sm font-semibold hover:bg-slate-100 active:scale-95 transition-all whitespace-nowrap"
          >
            Elegir Plan
          </button>
          {!expired && (
            <button
              onClick={() => setDismissed(true)}
              data-testid="trial-banner-dismiss-btn"
              className="p-1 text-white/70 hover:text-white"
              title="Recordarme luego"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      <UpgradeModal
        isOpen={showUpgrade}
        onClose={() => setShowUpgrade(false)}
        subscription={subscription}
        token={token}
        t={t}
        expired={expired}
      />
    </>
  );
};

export default TrialBanner;
